// Define health status as a numeric enum
export enum HealthStatusCode {
  EXCELLENT = 5,
  HEALTHY = 4,
  FAIR = 3,
  NEEDS_IMPROVEMENT = 2,
  AT_RISK = 1,
}

// Human-readable display text for each status code
export const HEALTH_STATUS_TEXT = {
  [HealthStatusCode.EXCELLENT]: 'Excellent',
  [HealthStatusCode.HEALTHY]: 'Healthy',
  [HealthStatusCode.FAIR]: 'Fair',
  [HealthStatusCode.NEEDS_IMPROVEMENT]: 'Needs Improvement',
  [HealthStatusCode.AT_RISK]: 'At Risk',
};

// For backward compatibility (to be deprecated)
export const HEALTH_STATUS = {
  EXCELLENT: 'Excellent',
  HEALTHY: 'Healthy',
  FAIR: 'Fair',
  NEEDS_IMPROVEMENT: 'Needs Improvement',
  AT_RISK: 'At Risk',
} as const;

export const HEALTH_THRESHOLDS = {
  EXCELLENT: 80,
  HEALTHY: 60,
  FAIR: 40,
  NEEDS_IMPROVEMENT: 20,
};

// Colors mapped to numeric status codes - Updated with new brand colors
export const HEALTH_COLORS = {
  [HealthStatusCode.EXCELLENT]: '#2AD352', // Ex/Healthy
  [HealthStatusCode.HEALTHY]: '#2AD352', // Ex/Healthy
  [HealthStatusCode.FAIR]: '#2196F3', // Fair
  [HealthStatusCode.NEEDS_IMPROVEMENT]: '#FF800C', // N. Improv.
  [HealthStatusCode.AT_RISK]: '#FF6174', // At Risk
} as const;

// For backward compatibility (to be deprecated) - Updated with new brand colors
export const HEALTH_COLORS_LEGACY = {
  [HEALTH_STATUS.EXCELLENT]: '#2AD352', // Ex/Healthy
  [HEALTH_STATUS.HEALTHY]: '#2AD352', // Ex/Healthy
  [HEALTH_STATUS.FAIR]: '#2196F3', // Fair
  [HEALTH_STATUS.NEEDS_IMPROVEMENT]: '#FF800C', // N. Improv.
  [HEALTH_STATUS.AT_RISK]: '#FF6174', // At Risk
} as const;

export type HealthStatusType = keyof typeof HEALTH_STATUS;

// Returns the numeric status code
export const getHealthStatusCode = (score: number): HealthStatusCode => {
  if (score >= HEALTH_THRESHOLDS.EXCELLENT) return HealthStatusCode.EXCELLENT;
  if (score >= HEALTH_THRESHOLDS.HEALTHY) return HealthStatusCode.HEALTHY;
  if (score >= HEALTH_THRESHOLDS.FAIR) return HealthStatusCode.FAIR;
  if (score >= HEALTH_THRESHOLDS.NEEDS_IMPROVEMENT) return HealthStatusCode.NEEDS_IMPROVEMENT;
  return HealthStatusCode.AT_RISK;
};

// For backward compatibility (returns string status)
export const getHealthStatus = (score: number): HealthStatusType => {
  const statusCode = getHealthStatusCode(score);
  return HEALTH_STATUS_TEXT[statusCode] as HealthStatusType;
};

// Get color by status code
export const getHealthColorByCode = (statusCode: HealthStatusCode): string => {
  return HEALTH_COLORS[statusCode];
};

// Get display text by status code
export const getHealthTextByCode = (statusCode: HealthStatusCode): string => {
  return HEALTH_STATUS_TEXT[statusCode];
};
